import { render, staticRenderFns } from "./StudentSupervisorSlidebar.vue?vue&type=template&id=760272ac"
import script from "./StudentSupervisorSlidebar.vue?vue&type=script&lang=js"
export * from "./StudentSupervisorSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports